<div class="page-header page-header__row">
  <div class="page-header__title-stack">
    <div class="page-title">
      <svg class="page-title__icon" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M2 0C0.895431 0 0 0.89543 0 2V2.5H14V2C14 0.89543 13.1046 0 12 0H2Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 4H0V9C0 10.1046 0.895431 11 2 11H12C13.1046 11 14 10.1046 14 9V4ZM2 6.5C2 6.22386 2.22386 6 2.5 6H6.5C6.77614 6 7 6.22386 7 6.5C7 6.77614 6.77614 7 6.5 7H2.5C2.22386 7 2 6.77614 2 6.5ZM2.5 8C2.22386 8 2 8.22386 2 8.5C2 8.77614 2.22386 9 2.5 9H4.5C4.77614 9 5 8.77614 5 8.5C5 8.22386 4.77614 8 4.5 8H2.5Z" fill="currentColor"/>
      </svg>
      <h1 class="page-title__text">Billing</h1>
    </div>
    <p class="page-title__sub">Your wallet balance, top-ups, and usage-based charges.</p>
  </div>

  <div class="billing-header__controls">
    <ng-content></ng-content>
    <a class="btn--secondary" routerLink="/support">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14ZM8 4.5a1.5 1.5 0 00-1.5 1.5.75.75 0 01-1.5 0 3 3 0 116 0c0 1.06-.68 1.68-1.19 2.1-.32.27-.56.47-.56.9v.25a.75.75 0 01-1.5 0v-.25c0-1.06.68-1.68 1.19-2.1.32-.27.56-.47.56-.9A1.5 1.5 0 008 4.5Zm.75 7.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0Z" fill="currentColor"/>
      </svg>
      Help &amp; FAQ
    </a>
  </div>
</div>

<nav class="billing-nav" aria-label="Billing sections">
  <a class="billing-nav__link" routerLink="/billing" routerLinkActive="billing-nav__link--active" [routerLinkActiveOptions]="{ exact: true }">Overview</a>
  <a class="billing-nav__link" routerLink="/billing/usage" routerLinkActive="billing-nav__link--active">Usage</a>
  <a class="billing-nav__link" routerLink="/billing/transactions" routerLinkActive="billing-nav__link--active">Transactions</a>
</nav>
